import script from "./OptionBox.vue?vue&type=script&setup=true&lang=js"
export * from "./OptionBox.vue?vue&type=script&setup=true&lang=js"

import "./OptionBox.vue?vue&type=style&index=0&id=689a1b85&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-689a1b85"]])

export default __exports__